// admin
export const FETCH_DEVELOPER = 'fetchDevelopers'
export const FETCHED_DEVELOPER = 'fetchedDevelopers'
export const CREATE_DEVELOPER = 'createDeveloper'
export const UPDATE_DEVELOPER = 'updateDeveloper'
export const DELETE_DEVELOPER = 'deleteDeveloper'

export const EXPORT_DEVELOPER = 'adminExportDevelopers'
export const SELECT_DEVELOPER = 'adminSelectDeveloper'
